import { motion } from "framer-motion";
import { ArrowUpRight, Check } from "@phosphor-icons/react";
import { waLink } from "@/lib/site";

export default function PackageCard({ pkg, index = 0 }) {
    return (
        <motion.article
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.7, delay: index * 0.06 }}
            className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-10 border-t border-white/10 py-10 lg:py-14 first:border-t-0 first:pt-0"
            data-testid={`package-card-${pkg.id}`}
        >
            <div className="lg:col-span-5 relative overflow-hidden aspect-[4/3] lg:aspect-[5/6] group">
                <img
                    src={pkg.image}
                    alt={pkg.name}
                    className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1500ms] group-hover:scale-105"
                />
                <div className="absolute top-4 left-4 bg-navy/70 backdrop-blur border border-white/10 px-3 py-1">
                    <p className="overline text-[10px]">{pkg.nights}</p>
                </div>
            </div>

            <div className="lg:col-span-7 flex flex-col">
                <p className="overline">Signature Package</p>
                <h3 className="font-serif text-3xl sm:text-4xl lg:text-5xl mt-3 leading-[1.05]">{pkg.name}</h3>

                <div className="mt-5 flex items-baseline gap-4">
                    <p className="font-serif text-3xl text-gold">{pkg.price}</p>
                    <p className="font-sans text-xs text-white/55 uppercase tracking-widest">{pkg.perPerson}</p>
                </div>

                <div className="mt-8 grid sm:grid-cols-2 gap-x-8 gap-y-2">
                    <div>
                        <p className="overline mb-3">Inclusions</p>
                        <ul className="space-y-2">
                            {pkg.inclusions.map((inc) => (
                                <li key={inc} className="flex items-center gap-2 font-sans text-sm text-white/75">
                                    <Check size={14} weight="bold" className="text-gold" /> {inc}
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div>
                        <p className="overline mb-3">Highlights</p>
                        <ul className="space-y-2">
                            {pkg.highlights.map((h) => (
                                <li key={h} className="font-sans text-sm text-white/65">— {h}</li>
                            ))}
                        </ul>
                    </div>
                </div>

                <div className="mt-10 flex flex-wrap items-center gap-3">
                    <a
                        href={waLink(`Hi! I'd like to book the "${pkg.name}" package.`)}
                        target="_blank"
                        rel="noreferrer"
                        data-testid={`package-book-wa-${pkg.id}`}
                        className="inline-flex items-center gap-2 bg-gold text-navy hover:bg-[#E5C158] px-7 py-3.5 font-sans font-medium uppercase tracking-wider text-xs transition-colors"
                    >
                        Book via WhatsApp <ArrowUpRight size={14} weight="bold" />
                    </a>
                    <a
                        href={`/contact?pkg=${encodeURIComponent(pkg.name)}`}
                        data-testid={`package-inquire-${pkg.id}`}
                        className="inline-flex items-center gap-2 border border-white/25 hover:border-gold hover:text-gold px-7 py-3.5 font-sans font-medium uppercase tracking-wider text-xs transition-colors"
                    >
                        Request Itinerary
                    </a>
                </div>
            </div>
        </motion.article>
    );
}
